import React from 'react';
import { Card, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import AppLayout from '../components/AppLayout';
import Verification from './Verification';
import './AdminPanel.css';

const { Title } = Typography;

const VerificatorPanel = () => {
  return (
    <AppLayout activeMenu="/verificator">
      <Card className="admin-content-card">
        <div className="admin-content-header">
          <Title level={3} style={{ margin: 0 }}>
            <CheckCircleOutlined style={{ marginRight: 12, color: '#14B8A6' }} />
            Content Verification
          </Title>
          <p style={{ margin: '8px 0 0 0', color: '#666' }}>
            Review and verify pending content submissions
          </p>
        </div>
        <Verification embedded />
      </Card>
    </AppLayout>
  );
};

export default VerificatorPanel;
